import { Component, OnInit, ViewChild } from '@angular/core';
import { RecSearchService } from '../../rec-search-service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { CityTownEXComponent } from '../../../shared/components/city-town-ex/city-town-ex.component';
import { DoctypeexComponent } from '../../../shared/components/doctypeex/doctypeex.component';
import { DaterangeComponent } from '../../../shared/components/daterange/daterange.component';
import * as DateRangeActions from '../../../store/actions/daterange.action';
import * as CityActions from '../../../store/actions/citytown.action';
import * as DocTypeActions from '../../../store/actions/doctype.action';
import { NgForm, UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { DateRangeParentComponent } from '../../../shared/components/date-range-parent/date-range-parent.component';


@Component({
  selector: 'app-rec-date-search',
  providers: [RecSearchService],
  templateUrl: './rec-date-search.component.html',
  styleUrls: ['./rec-date-search.component.css']
})
export class RecDateSearchComponent implements OnInit {

  //@ViewChild(DaterangeComponent) dateRangeChild;
  @ViewChild(DateRangeParentComponent, { static: true }) dateRangeChild;
  @ViewChild(CityTownEXComponent, { static: true }) cityTownChild;
  @ViewChild(DoctypeexComponent, { static: true }) docTypeChild;
  @ViewChild('f', { static: true }) recDateSearchForm: NgForm;
  parentForm: UntypedFormGroup;


  constructor(private router: Router, private service: RecSearchService, private store: Store<AppState>, private fb: UntypedFormBuilder) {


  }
  addRecToStore( fromdate, todate, citytowns, doctypes) {
    this.store.dispatch(new DateRangeActions.AddDate({
      fromDate: fromdate,
      toDate: todate
    }));

    this.store.dispatch(new CityActions.AddCity({
      citytowns: citytowns
    }));

    this.store.dispatch(new DocTypeActions.AddDoct({
      doctypes: doctypes
    }));
  }

  delRecFromStore(index) {
    this.store.dispatch(new CityActions.RemoveCity(index));
    this.store.dispatch(new DateRangeActions.RemoveDate(index));
    this.store.dispatch(new DocTypeActions.RemoveDoct(index));
  }

  ngOnInit() {
    //this.parentForm = this.fb.group({
    //  //compoundName: this.fb.group({
    //  //  lastcorpName: ['', Validators.required],
    //  //  fName: ['']
    //  //})
    //});

    //this.recDateSearchForm.form = this.fb.group({});
    //this.dateRangeChild.utilityobj.fromDate = '1/1/1962';
    //this.dateRangeChild.utilityobj.toDate = '12/31/2020';
  }

  search(url) {

    this.delRecFromStore(0);

    this.addRecToStore(this.dateRangeChild.utilityobj.fromDate, this.dateRangeChild.utilityobj.toDate, this.cityTownChild.utilityobj.citytowns, this.docTypeChild.utilityobj.doctypes);

    this.router.navigate([url]);

  }
  onSubmit(e) {
    if (this.recDateSearchForm.valid) {

      this.delRecFromStore(0);

      this.addRecToStore(this.dateRangeChild.utilityobj.fromDate, this.dateRangeChild.utilityobj.toDate, this.cityTownChild.utilityobj.citytowns, this.docTypeChild.utilityobj.doctypes);

      this.router.navigate(['/rec-date-result-pg']);

    }
    else {
      this.validateAllFormFields(this.recDateSearchForm.form);
    }

  }

  /**
 * Search registered land name search results.
 * @param url
 */
  validateAllFormFields(formGroup: UntypedFormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof UntypedFormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }



  ngAfterViewInit() {
    //this.parentForm.addControl('compoundName', this.compoundNameChild.form);
    //this.compoundNameChild.form.setParent(this.parentForm);

    this.parentForm = this.fb.group({
      //compoundName: this.fb.group({
      //  lastcorpName: ['', Validators.required],
      //  fName: ['']
      //})
    });

    this.recDateSearchForm.form = this.fb.group({});
    this.dateRangeChild.utilityobj.fromDate = '1/1/1962';
    this.dateRangeChild.utilityobj.toDate = '12/31/2020';

    this.recDateSearchForm.form.addControl('dateRangeForm', this.dateRangeChild.form);
    this.dateRangeChild.form.setParent(this.recDateSearchForm.form);
  }

}
